module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-layout', {
    staticClass: "overflow-x-hidden",
    attrs: {
      "home": true
    }
  }, [_c('div', {
    staticClass: "home flex-inline justify-between"
  }, [_c('div', {
    staticClass: "logointro"
  }, [_c('img', {
    staticClass: "logointro2",
    attrs: {
      "src": require("@/assets/newlogos/logos_intro_DOAJC_montage.png")
    }
  })]), _c('div', {
    staticClass: "soustitreintro mb1 ph2"
  }, [_c('h1', [_vm._v("The amazing story of a group of jewish songwriters who wrote the soundtrack to christmas")])]), _c('div', {
    staticClass: "enterbouton pb5 pt1"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'hello'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/enter_bouton.svg"),
      "width": "100px"
    }
  })])], 1), _c('div', {
    staticClass: "bandeauinfos pt2 pb3 shadow-up-4"
  }, [(_vm.date_de_diffusion.length > 0) ? _c('q-carousel', {
    staticClass: "text-white",
    attrs: {
      "infinite": "",
      "autoplay": ""
    }
  }, _vm._l((_vm.date_de_diffusion[0].page_containers), function(date) {
    return _c('div', {
      staticClass: "sliderstyle2",
      slot: "slide"
    }, [_c('div', {
      staticClass: "w-100 flex-inline"
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(date.container.description)
      }
    }), (date.container.medias.length > 0) ? _c('div', {
      staticClass: "images"
    }, [_c('img', {
      staticClass: "pl2",
      attrs: {
        "src": date.container.medias[0].image.url
      }
    })]) : _vm._e()])])
  })) : _vm._e()], 1), _c('q-carousel', {
    staticClass: "carousellogos text-white",
    attrs: {
      "infinite": "",
      "autoplay": ""
    }
  }, [_c('div', {
    staticClass: "sliderstyle",
    slot: "slide"
  }, [_c('div', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/373x100/cbc-cropped.png"),
      "width": "85px;"
    }
  })])]), _c('div', {
    staticClass: "sliderstyle",
    slot: "slide"
  }, [_c('div', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/373x100/svt-cropped.png"),
      "width": "100px;"
    }
  })])]), _c('div', {
    staticClass: "sliderstyle",
    slot: "slide"
  }, [_c('div', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/373x100/documentary-cropped.png"),
      "width": "120px;"
    }
  })])]), _c('div', {
    staticClass: "sliderstyle",
    slot: "slide"
  }, [_c('div', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/373x100/arte-cropped.png"),
      "width": "100px;"
    }
  })])]), _c('div', {
    staticClass: "sliderstyle",
    slot: "slide"
  }, [_c('div', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/373x100/rogers-cropped.png"),
      "width": "150px;"
    }
  })])]), _c('div', {
    staticClass: "sliderstyle",
    slot: "slide"
  }, [_c('div', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/373x100/yle-cropped.png"),
      "width": "50px;"
    }
  })])]), _c('div', {
    staticClass: "sliderstyle",
    slot: "slide"
  }, [_c('div', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/373x100/NK-cropped.png"),
      "width": "70px;"
    }
  })])]), _c('div', {
    staticClass: "sliderstyle",
    slot: "slide"
  }, [_c('div', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/373x100/ndr-cropped.png"),
      "width": "80px;"
    }
  })])]), _c('div', {
    staticClass: "sliderstyle",
    slot: "slide"
  }, [_c('div', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/373x100/RSI-cropped.png"),
      "width": "60px;"
    }
  })])]), _c('div', {
    staticClass: "sliderstyle",
    slot: "slide"
  }, [_c('div', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/373x100/cmf-cropped.png"),
      "width": "200px;"
    }
  })])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0454c0d2","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 1272
// module chunks = 1